import { render, staticRenderFns } from "./GuangdongUnicomJC01.vue?vue&type=template&id=dc7e1ae8&scoped=true"
import script from "./GuangdongUnicomJC01.vue?vue&type=script&lang=js"
export * from "./GuangdongUnicomJC01.vue?vue&type=script&lang=js"
import style0 from "./GuangdongUnicomJC01.vue?vue&type=style&index=0&id=dc7e1ae8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7e1ae8",
  null
  
)

export default component.exports